import React from 'react';
import { toast, cssTransition } from 'react-toastify';

/**
 * The app's one way to tell someone something happened — a slim pill that
 * drops in at the top, says it, and goes.
 *
 * Replaces browser `alert()`, which blocks the page and reads "1to19.com
 * says…". The first version was a full-width card with a countdown bar and a
 * close button that sat there for 4–6 seconds; the owner found it slow and
 * heavy. Now: no bar, no close button, short times (a success barely needs
 * reading), and a tap or a swipe dismisses it.
 *
 *   success  it worked                     1.8s
 *   warn     fix this before going on      3s
 *   error    it failed                     4.5s
 *
 * `toast` returns an id, so `return notify.warn(...)` still ends a handler.
 */
export const pillTransition = cssTransition({
  enter: 'app-toast-in',
  exit: 'app-toast-out',
  collapseDuration: 160,
});

const Glyph = ({ kind }) => (
  <span className={`app-toast-glyph app-toast-glyph--${kind}`} aria-hidden="true">
    {kind === 'success' ? '✓' : kind === 'warn' ? '!' : '×'}
  </span>
);

const show = (kind, ms) => (msg) => toast(msg, {
  className: `app-toast app-toast--${kind}`,
  icon: <Glyph kind={kind} />,
  autoClose: ms,
  type: kind === 'warn' ? 'warning' : kind,
});

export const notify = {
  success: show('success', 1800),
  warn: show('warn', 3000),
  error: show('error', 4500),
};

export default notify;
